// extracted by mini-css-extract-plugin
module.exports = {"container":"Blogs_container__V6UA1","blog_card":"Blogs_blog_card__kM8Yx","blog_img_overlay":"Blogs_blog_img_overlay__agIRW"};